<template>
  <div class="basic-layout">
    <GloablHeader />
    <main class="main-content">
      <router-view v-slot="{ Component }">
        <transition name="fade" mode="out-in">
          <component :is="Component" />
        </transition>
      </router-view>
    </main>
    <GlobalFooter />
    <!-- 添加悬浮联系按钮 -->
    <FloatingContactButtons />
  </div>
</template>

<script setup lang="ts">
import GloablHeader from '../components/GloablHeader.vue';
import GlobalFooter from '../components/GlobalFooter.vue';
import FloatingContactButtons from '../components/FloatingContactButtons.vue';
</script>
<style scoped>
/* 移除可能影响层级的样式 */
#basicLayout {
  width: 100%;
  max-width: 100vw;
}

.layout-container {
  width: 100%;
  max-width: 100vw;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.main-content {
  color: white;
  padding-top: 80px; /* 为固定头部留出空间 */
  padding-bottom: 20px; /* 为页脚留出空间 */
  padding-left: 0;
  padding-right: 0;
  margin: 0;
  width: 100%;
  flex: 1; /* 让main-content占据剩余空间 */
}
</style>
